import { useUserStore } from "@/store/useUserStore";
import { clearSession as clearSessionUtil } from "@/utils/clearSession";
import { type PropsWithChildren, useCallback, useMemo } from "react";
import { createContext } from "use-context-selector";

type AuthContextType = {
  isAuthenticated: boolean;
  clearSession: () => Promise<void>;
};

export const AuthContext = createContext({} as AuthContextType);

export function AuthProvider({ children }: PropsWithChildren) {
  const userId = useUserStore((s) => s.id);

  const clearSession = useCallback(() => clearSessionUtil(), []);

  const value = useMemo(
    () => ({ isAuthenticated: !!userId, clearSession }),
    [userId, clearSession],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
